export const EDIT_TRIAGE_AGENT_CONFIGURATION_TEXT = 'Edit triage agent configuration'
export const CREATE_TRIAGE_AGENT_CONFIGURATION_TEXT = 'Create triage agent configuration'
